/**
 * Whether an href points back at this site.
 *
 * Relative hrefs always do. An absolute one has to sit on the host we are being served from —
 * `target="_self"` alone used to stand in for this, which meant an external link set to open in
 * the same tab was handed to the client-side router, and clicking it took the reader to this
 * site's own root rather than the address they asked for.
 */
export const isSameSiteHref = (href: string, siteUrl?: string): boolean => {
  if (!href) return false;
  if (href.startsWith('/') || href.startsWith('#')) return true;

  try {
    return new URL(href).hostname === new URL(siteUrl ?? '').hostname;
  } catch {
    return false;
  }
};
